import React from "react";
import moment from "moment";
import { translate } from "../../../Components/Lib/Languages/language";
import BootstrapTable from "react-bootstrap-table-next";
class InschrijvingenComponent extends React.Component {
  render() {
    const { reserveringen, horeca, datum } = this.props;

    function datumact(cell) {
      return moment(cell).format("DD-MM-YYYY");
    }
    function priceFormatter(cell, row) {
      return moment(cell).format("DD-MM-YYYY HH:mm");
    }
    function tafel(cell, row) {
      if (cell === 0) {
        return "Terras";
      } else if (cell === 1) {
        return "Binnenlocatie";
      } else {
        return cell;
      }
    }
    const columns = [
      {
        dataField: "datum",
        text: "Datum",
        formatter: priceFormatter,
      },
      {
        dataField: "tafel",
        text: "Tafel",
        formatter: tafel,
      },
      {
        dataField: "gasten.naam",
        text: "Naam",
        sort: true,
      },
      {
        dataField: "gasten.email",
        text: "E-mailadres",
      },
      {
        dataField: "personen",
        text: "Personen",
      },
    ];

    return (
      <div className="box-header with-border">
        <h2 className="page-header">
          {translate(horeca.naam)}
          <small className="pull-right">{datumact(datum)}</small>
        </h2>
        <div className="box-body box-profile inschrijving"></div>
        <div className="box-body box-profile inschrijving">
          <BootstrapTable wrapperClasses="table-responsive-md" keyField="_id" data={reserveringen} columns={columns} defaultSorted={[{ dataField: "gasten.naam", order: "asc" }]} />
        </div>
      </div>
    );
  }
}
export default InschrijvingenComponent;
